var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-friends-dialog-wrapper"},[_c('DialogPopup',{attrs:{"show":_vm.value,"width":"470px","append-to-body":true}},[_c('InviteFriedns',{on:{"icon-click":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }